import { render } from "./FooterLinks.vue?vue&type=template&id=441b2d59&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"

import "./FooterLinks.vue?vue&type=style&index=0&id=441b2d59&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441b2d59"]])

export default __exports__